<template>
  <div>
    <div class="widget-body order-entry-dialog">
      <div
        class="main-panel"
        v-if="this.state === 'preview' || this.state === 'submitPending' || this.state === 'confirmation'"
      >
        <div class="horizontal-panel">
          <div class="content-panel">
            <table class="table">
              <tr>
                <td :class="{ red: isSell[0], green: isBuy[0] }" class="info" colspan="3">{{ orderInformation[0] }}</td>
              </tr>
              <tr v-if="!isMLO">
                <td>{{ i18n('orderEntryDialog.principal') }}</td>
                <td>{{ principal[0] }}</td>
                <td class="right-column"></td>
              </tr>
              <tr v-if="!isMLO">
                <td>{{ i18n('orderEntryDialog.commission') }}</td>
                <td>{{ commission[0] }}</td>
              </tr>
              <tr v-if="!isMLO">
                <td>{{ i18n('orderEntryDialog.totalValue') }}</td>
                <td>{{ totalValue[0] }}</td>
              </tr>

              <tr v-if="isSecondLeg || isMLO">
                <td :class="{ red: isSell[1], green: isBuy[1] }" class="info" colspan="3">{{ orderInformation[1] }}</td>
              </tr>
              <tr v-if="isSecondLeg && !isMLO">
                <td>{{ i18n('orderEntryDialog.principal') }}</td>
                <td>{{ principal[1] }}</td>
              </tr>
              <tr v-if="isSecondLeg && !isMLO">
                <td>{{ i18n('orderEntryDialog.commission') }}</td>
                <td>{{ commission[1] }}</td>
              </tr>
              <tr v-if="isSecondLeg && !isMLO">
                <td>{{ i18n('orderEntryDialog.totalValue') }}</td>
                <td>{{ totalValue[1] }}</td>
              </tr>

              <tr v-if="isThirdLeg && !isMLO">
                <td :class="{ red: isSell[2], green: isBuy[2] }" class="info" colspan="3">{{ orderInformation[2] }}</td>
              </tr>
              <tr v-if="isThirdLeg && !isMLO">
                <td>{{ i18n('orderEntryDialog.principal') }}</td>
                <td>{{ principal[2] }}</td>
              </tr>
              <tr v-if="isThirdLeg && !isMLO">
                <td>{{ i18n('orderEntryDialog.commission') }}</td>
                <td>{{ commission[2] }}</td>
              </tr>
              <tr v-if="isThirdLeg && !isMLO">
                <td>{{ i18n('orderEntryDialog.totalValue') }}</td>
                <td>{{ totalValue[2] }}</td>
              </tr>

              <tr>
                <td class="divider" colspan="3"></td>
              </tr>
              <tr>
                <td>{{ i18n('orderEntryDialog.account') }}</td>
                <td>{{ accountInfo }}</td>
                <td class="right-column"></td>
              </tr>
              <tr v-if="isBuyingPower">
                <td>{{ i18n('orderEntryDialog.buyingPower') }}</td>
                <td>{{ buyingPower }}</td>
              </tr>
              <tr v-if="isMLO">
                <td>{{ i18n('orderEntryDialog.price') }}</td>
                <td>{{ multilegPrice }}</td>
              </tr>
              <tr v-if="isMLO">
                <td>{{ i18n('orderEntryDialog.duration') }}</td>
                <td>{{ multilegDuration }}</td>
              </tr>
              <tr v-if="isMLO">
                <td>{{ i18n('orderEntryDialog.principal') }}</td>
                <td>{{ multilegPrincipal }}</td>
              </tr>
              <tr v-if="isMLO">
                <td>{{ i18n('orderEntryDialog.commission') }}</td>
                <td>{{ multilegCommission }}</td>
              </tr>
              <tr v-if="isMLO">
                <td>{{ i18n('orderEntryDialog.totalValue') }}</td>
                <td>{{ multilegTotalValue }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div
          class="horizontal-panel"
          v-if="explicitAcknowledgements.length > 0 || acknowledgements.size > 0 || state === 'confirmation'"
        >
          <div :class="'message-panel-' + messageColor">
            <div :class="'icon-panel-' + messageColor">
              <font-awesome-icon class="fa-3x mt5" :icon="['fas', `${messageIcon}`]" />
            </div>
            <div class="text-container-panel">
              <div
                class="text-panel"
                v-for="acknowledgement in acknowledgements"
                :key="acknowledgement"
                v-if="state === 'preview' || state === 'submitPending'"
              >
                <span>
                  {{ acknowledgement }}
                </span>
              </div>
              <v-form-group v-if="explicitAcknowledgements.length > 0 || acknowledgements.size > 0">
                <v-form-checkbox-group v-model="acknowledged" :options="explicitAcknowledgements" />
              </v-form-group>
              <div class="order-confirmation" v-if="state === 'confirmation'">
                <span>
                  {{ confirmationText }}
                </span>
              </div>
              <div v-if="state === 'confirmation'">
                <div class="order-info" v-for="orderInfo in orderInfos" :key="orderInfo.id">
                  <span>
                    {{ orderInfo.id }}
                  </span>
                  <span>
                    {{ orderInfo.date }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="widget-footer">
      <div class="button-container">
        <v-button
          class="left-footer-button"
          @click="$emit('cancel')"
          v-if="state === 'preview' || state === 'submitPending'"
          >{{ i18n('orderEntryDialog.footer.editOrder') }}</v-button
        >
        <v-button
          class="right-footer-button"
          variant="primary"
          @click="submit"
          :disabled="!isSubmitEnabled"
          v-if="state === 'preview' || state === 'submitPending'"
        >
          <font-awesome-icon class="spinner" icon="circle-notch" spin v-if="state === 'submitPending'" />
          {{ i18n('orderEntryDialog.footer.submitOrder') }}</v-button
        >
        <v-button class="right-footer-button" variant="primary" @click="$emit('close')" v-if="state === 'confirmation'">
          {{ i18n('orderEntryDialog.footer.closeOrder') }}</v-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import orderUtils from '@widgets/WOrderEntryWidget/orderUtils.js';
import moment from 'moment';

export default {
  name: 'w-order-entry-widget',
  mixins: [orderUtils],
  props: {
    wid: {
      type: String,
      required: true
    },
    state: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    isBuyingPower: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      acknowledged: []
    };
  },
  computed: {
    confirmationText() {
      return this.i18n('orderEntryDialog.confirmationText');
    },
    messageColor() {
      if (this.state === 'preview' || this.state === 'submitPending') {
        return 'yellow';
      } else if (this.state === 'confirmation') {
        return 'green';
      }
    },
    messageIcon() {
      if (this.state === 'preview' || this.state === 'submitPending') {
        return 'exclamation-triangle';
      } else if (this.state === 'confirmation') {
        return 'check-circle';
      }
    },
    isSell() {
      let sells = [];
      this.data.orderTerms.order.forEach(order => {
        let action = order.extendedTerms.orderAction.toLowerCase();
        sells.push(action.includes('sell'));
      });
      return sells;
    },
    isBuy() {
      let buys = [];
      this.data.orderTerms.order.forEach(order => {
        let action = order.extendedTerms.orderAction.toLowerCase();
        buys.push(action.includes('buy'));
      });
      return buys;
    },
    isSecondLeg() {
      return this.data.orderTerms.order.length > 1;
    },
    isThirdLeg() {
      return this.data.orderTerms.order.length > 2;
    },
    isMLO() {
      return this.data.orderTerms.strategy === 'MLO';
    },
    isSubmitEnabled() {
      return this.explicitAcknowledgements.length === this.acknowledged.length;
    },
    acknowledgements() {
      let acknowledgements = new Set([]);
      if (this.state === 'preview' || this.state === 'submitPending') {
        if (this.data.conditions.conditions.ACTIONREQUIRED) {
          this.data.conditions.conditions.ACTIONREQUIRED.forEach(acknowledgement => {
            acknowledgements.add(acknowledgement.description + ' [' + acknowledgement.code + ']');
          });
        }
        if (this.data.conditions.conditions.ACKNOWLEDGEMENTREQUIRED) {
          this.data.conditions.conditions.ACKNOWLEDGEMENTREQUIRED.forEach(acknowledgement => {
            acknowledgements.add(acknowledgement.description + ' [' + acknowledgement.code + ']');
          });
        }
      }
      return acknowledgements;
    },
    explicitAcknowledgements() {
      let acknowledgements = [];
      if (this.state === 'preview' || this.state === 'submitPending') {
        if (this.data.conditions.conditions.EXPLICITACKNOWLEDGEMENTREQUIRED) {
          let index = 0;
          this.data.conditions.conditions.EXPLICITACKNOWLEDGEMENTREQUIRED.forEach(acknowledgement => {
            acknowledgements.push({
              text: acknowledgement.description + ' [' + acknowledgement.code + ']',
              value: index++
            });
          });
        }
        // if (this.data.conditions.conditions.ACKNOWLEDGEMENTREQUIRED) {
        //   let index = 0;
        //   this.data.conditions.conditions.ACKNOWLEDGEMENTREQUIRED.forEach(acknowledgement => {
        //     acknowledgements.push({
        //       text: acknowledgement.description + ' [' + acknowledgement.code + ']',
        //       value: index++
        //     });
        //   });
        // }
      }
      return acknowledgements;
    },
    legDescription() {
      return '';
    },
    accountInfo() {
      let accountInfo = this.data.orderTerms.accountInfo;
      const acctTypeNamespace = `white-label.widgets.accountDetails.accountType.${this._.camelCase(
        accountInfo.acctType
      )}`;
      return `${accountInfo.accountNumber} - ${accountInfo.currency} ${this.$t(acctTypeNamespace)}`;
    },
    buyingPower() {
      let buyingPower = this.data.orderTerms.accountInfo.orderBuyingPower;
      if (!buyingPower) {
        buyingPower = 0;
      }
      return this.$f(buyingPower, 'float.price');
    },
    orderInformation() {
      let infos = [];
      let strategy = this.data.orderTerms.strategy;
      let index = 1;
      let securityTypes = [];
      this.data.orderTerms.order.forEach(order => {
        securityTypes.push(order.security.type);
      });
      this.data.orderTerms.order.forEach(order => {
        let action = this.toCamelCase(order.extendedTerms.orderAction);
        action = this.i18n('actions.' + action);
        let quantity = order.quantity || order.dollarAmt;
        if (order.hasOwnProperty('dollarAmt')) {
          quantity = this.$f(quantity, 'float.priceTD');
        } else {
          quantity = this.$f(quantity, 'float.fractionalQuantity');
        }
        let instrument = this.getInstrumentInfo(order);
        let price = this.getPriceInfo(order);
        let duration = this.getDurationInfo(order.extendedTerms.goodTill, order.extendedTerms.goodTillDate);

        let info = `${action} ${
          !order.hasOwnProperty('dollarAmt')
            ? `${quantity}`
            : `$${quantity} ${this.i18n('orderEntryDialog.infoText.of')}`
        } ${instrument}`;
        if (strategy === 'SPL' || strategy === 'OCO' || strategy === 'OTA' || strategy === 'FTO') {
          info += ' @ ' + price + ' ' + duration;
        }
        if (strategy !== 'SPL') {
          let legDescription;
          if (strategy === 'MLO') {
            if (order.security.type === 'EQUITY') {
              legDescription = this.i18n('strategy.stock');
            } else if (order.security.type === 'OPTION') {
              if ((index === 1 && securityTypes[1] === 'OPTION') || (index === 2 && securityTypes[0] === 'OPTION')) {
                legDescription = this.i18n('strategy.option' + index);
              } else {
                legDescription = this.i18n('strategy.option');
              }
            }
          } else {
            legDescription = this.i18n('orderEntryDialog.infoText.' + strategy.toLowerCase() + index);
          }
          info = legDescription + '\n' + info;
        }
        infos.push(info);
        index++;
      });
      return infos;
    },
    principal() {
      let principals = [];
      this.data.orderTerms.order.forEach(order => {
        principals.push(
          this.$f(order.orderEstimate.principalValue, 'float.price') + ' ' + order.orderEstimate.currencySymbol
        );
      });
      return principals;
    },
    multilegPrincipal() {
      let orderEstimate = this.data.orderTerms.multilegEntry.orderEstimate;
      let principal = '--';
      if (orderEstimate && orderEstimate.principalValue) {
        principal = this.$f(orderEstimate.principalValue, 'float.price');
      }
      return principal + this.getCurrencySymbol(orderEstimate);
    },
    commission() {
      let commissions = [];
      this.data.orderTerms.order.forEach(order => {
        commissions.push(
          this.$f(order.orderEstimate.commission, 'float.price') + ' ' + order.orderEstimate.currencySymbol
        );
      });
      return commissions;
    },
    multilegCommission() {
      let orderEstimate = this.data.orderTerms.multilegEntry.orderEstimate;
      let commission = '--';
      if (orderEstimate && orderEstimate.commission) {
        commission = this.$f(orderEstimate.commission, 'float.price');
      }
      return commission + this.getCurrencySymbol(orderEstimate);
    },
    totalValue() {
      let totals = [];
      this.data.orderTerms.order.forEach(order => {
        totals.push(this.$f(order.orderEstimate.total, 'float.price') + ' ' + order.orderEstimate.currencySymbol);
      });
      return totals;
    },
    multilegTotalValue() {
      let orderEstimate = this.data.orderTerms.multilegEntry.orderEstimate;
      let totalValue = '--';
      if (orderEstimate && orderEstimate.total) {
        totalValue = this.$f(orderEstimate.total, 'float.price');
      }
      return totalValue + this.getCurrencySymbol(orderEstimate);
    },
    multilegPrice() {
      let multilegEntry = this.data.orderTerms.multilegEntry;
      let pricePlan = this.data.orderTerms.pricePlan;
      let multilegPrice = this.i18n('priceTypes.' + this.toCamelCase(pricePlan));
      if (pricePlan === 'NET_CREDIT' || pricePlan === 'NET_DEBIT') {
        multilegPrice +=
          ' ' +
          this.$f(multilegEntry.extendedTerms.limitPrice, 'float.price') +
          this.getCurrencySymbol(multilegEntry.orderEstimate);
      }
      return multilegPrice;
    },
    multilegDuration() {
      let extendedTerms = this.data.orderTerms.multilegEntry.extendedTerms;
      return this.getDurationInfo(extendedTerms.goodTill, extendedTerms.goodTillDate);
    },
    orderInfos() {
      const orderInfos = [];
      this.data.orderTerms.order.forEach(order => {
        const id = this.i18n('orderEntryDialog.orderId') + ': ' + order.orderNumber;
        const dateStr = order.details.lastUpdatedTimestamp.replace(/-(\d\d)(\d\d)$/g, '-$1:$2');
        const date = this.i18n('orderEntryDialog.orderDate') + ': ' + this.$f(dateStr, 'datetime');
        orderInfos.push({ id: id, date: date });
      });
      return orderInfos;
    }
  },
  methods: {
    i18n(subkey) {
      return this.$t(`white-label.${'widgets.orderEntry'}.${subkey}`);
    },
    getCurrencySymbol(orderEstimate) {
      let currencySymbol = '';
      if (orderEstimate && orderEstimate.currencySymbol) {
        currencySymbol = ' ' + orderEstimate.currencySymbol;
      }
      return currencySymbol;
    },
    getInstrumentInfo(order) {
      if (order.security.type === 'OPTION') {
        return (
          order.security.symbol +
          ' ' +
          order.security.market +
          ' ' +
          moment(order.security.extendedTerms.contractExpiry).format('DDMMMYY') +
          ' ' +
          this.$f(order.security.extendedTerms.strikePrice, 'float.price') +
          ' ' +
          this.i18n('optionTypes.short.' + order.security.extendedTerms.type.toLowerCase())
        );
      } else {
        return order.security.displayTicker + ' ' + order.security.market;
      }
    },
    getPriceInfo(order) {
      let priceType = order.extendedTerms.orderType;
      if (priceType === 'MARKET') {
        return this.getPriceTypeName(priceType);
      } else if (priceType === 'LIMIT') {
        return this.getLimitText(order);
      } else if (priceType === 'STOP_MARKET') {
        return this.getStopMarketText(order);
      } else if (priceType === 'STOP_LIMIT') {
        return this.getStopLimitText(order);
      } else if (priceType === 'TRAILING_STOP_MARKET') {
        return this.getTrailingStopMarketText(order);
      } else if (priceType === 'TRAILING_STOP_LIMIT') {
        return this.getTrailingStopLimitText(order);
      }
    },
    getPriceTypeName(priceType) {
      return this.i18n('priceTypes.' + this.toCamelCase(priceType));
    },
    getLimitText(order) {
      return this.$f(order.extendedTerms.limitPrice, 'float.price') + ' ' + this.getPriceTypeName('LIMIT');
    },
    getStopMarketText(order) {
      return this.$f(order.extendedTerms.triggerPrice, 'float.price') + ' ' + this.getPriceTypeName('STOP_MARKET');
    },
    getStopLimitText(order) {
      return (
        this.$f(order.extendedTerms.triggerPrice, 'float.price') +
        ' ' +
        this.getPriceTypeName('STOP_LIMIT') +
        ' ' +
        this.getLimitText(order)
      );
    },
    getTrailingStopMarketText(order) {
      let deltaAmount = order.extendedTerms.trailingStopTerms.deltaAmount;
      if (deltaAmount) {
        return '$' + this.$f(deltaAmount, 'float.price') + ' ' + this.getPriceTypeName(order.extendedTerms.orderType);
      }
      let deltaPercent = order.extendedTerms.trailingStopTerms.deltaPercent;
      if (deltaPercent) {
        return this.$f(deltaPercent, 'float.price') + '% ' + this.getPriceTypeName(order.extendedTerms.orderType);
      }
    },
    getTrailingStopLimitText(order) {
      return (
        this.getTrailingStopMarketText(order) +
        ' ' +
        this.$f(order.extendedTerms.trailingStopTerms.limitDelta, 'float.price') +
        ' ' +
        this.getPriceTypeName('LIMIT')
      );
    },
    getDurationInfo(type, date) {
      if (type) {
        const goodTill = this.toFCDuration(type);
        if (goodTill === 'gtd') {
          return (
            this.$t('white-label.globalLabels.trading.duration.options.dialog.gtd') +
            ' ' +
            moment(date)
              .utcOffset(-240)
              .format('MMM DD')
          );
        } else {
          return this.$t('white-label.globalLabels.trading.duration.options.dialog.' + goodTill);
        }
      }
    },
    submit() {
      this.$emit('submit');
    }
  }
};
</script>

<style></style>
